import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { useEffect } from 'react';

import { type QueryStateSchema, backwardsCompatabilityFactory, queryParam, queryStateParser } from './queryStateParser';

const QS_KEY = 'paneFollowups';
const QS_TYPE: QueryStateSchema['type'] = 'aiFollowups';

export const useOpenFollowupsPane = (): ((args: { aiFollowups: string }) => void) => {
  const [aiFollowupsDeprecated, setAiFollowups] = useQueryState(QS_KEY, { history: 'push' });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (aiFollowupsDeprecated) {
      setAiFollowups(null);
      setState(backwardsCompatabilityFactory({ id: aiFollowupsDeprecated, type: QS_TYPE }));
    }
  }, [aiFollowupsDeprecated]);

  return ({ aiFollowups }) => {
    setState((prevState) => [
      ...(prevState || []),
      {
        id: aiFollowups,
        key: nanoid(),
        type: QS_TYPE,
      },
    ]);
  };
};
